export default __webpack_public_path__ + "static/media/csc_01.a4ca42be.png";